// src/pages/Home/Home.jsx
import React from 'react';
import HeroSection from './Components/HeroSection';
import FeaturedProducts from './Components/FeaturedProducts';
import NewProduct from './Components/NewProduct';
import Discount from './Components/Discount';
import CreativleyProduct from './Components/CreativleyProduct';
import FAQ from './Components/FAQ';
import Banner2 from './Components/Banner2';

function Home() {
  return (
    <>
      <HeroSection />
      <FeaturedProducts />
      <NewProduct />
      <Discount />
      <CreativleyProduct />
      <FAQ />
      <Banner2 />
    </>
  );
}

export default Home;